import { render, staticRenderFns } from "./Noti.vue?vue&type=template&id=34c45164&scoped=true"
import script from "./Noti.vue?vue&type=script&lang=js"
export * from "./Noti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c45164",
  null
  
)

export default component.exports